import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteUnitSchedule = async (scheduledId: number): Promise<boolean> =>
  axios.delete(`/my-monitoring/sites/RemoveSchedule?scheduledId=${scheduledId}`).then((res) => res?.data?.result)

type Props = {
  scheduledId: number
}

export const useMyMonitoringDeleteUnitSchedule = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteMyMonitoringUnitSchedule'],
    mutationFn: ({ scheduledId }: Props) => deleteUnitSchedule(scheduledId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted schedule.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to delete schedule, please try again.')
      }
    },
    throwOnError: false
  })
